import { EditorEligibilityRule } from './editor-eligibility-rule.model';


export class EditorEligibilityRuleHasBookingType extends EditorEligibilityRule {
  className = 'HasBookingType';
  operatorName = 'hasBookingType';

  bookingTypes: string[];
  // states: string[];
  stateNamesString: string;
  metadata: string[];

  constructor(obj?: any) {
    super({
      id: obj?.id ?? null
    });
    this.bookingTypes = obj?.bookingTypes ?? [];
    // this.states = obj?.states ?? [];
    this.stateNamesString = obj?.stateNamesString ?? '';
    this.metadata = obj?.metadata ?? [];
  }

  static matchesTypeOfLegacySerializedValues(legacyEligibilityRules: any) {
    return legacyEligibilityRules?.args?.[0]?.args?.[0]?.op === 'fetchFromES'
      && legacyEligibilityRules?.args?.[0]?.args?.[0]?.options?.type === 'booking'
      && legacyEligibilityRules?.args?.[0]?.args?.[0]?.options?.filter?.bookingType !== undefined;
  }

  static getFromLegacySerializedValues(legacyEligibilityRules: any) {
    let states = legacyEligibilityRules.args[0].args[0].options.filter?.['es_extra.stateName'];
    if (typeof(states) === 'string') {
      states = [states];
    }

    const metadata = Object.keys(legacyEligibilityRules.args[0].args[0].options.filter)
      .filter(key => key.substring(0, 8) === 'metadata')
      .map(key => key.substring(9));

    return new this({
      bookingTypes: typeof(legacyEligibilityRules.args[0].args[0].options.filter.bookingType) === 'string'
      ? [legacyEligibilityRules.args[0].args[0].options.filter.bookingType]
      : legacyEligibilityRules.args[0].args[0].options.filter.bookingType,
      stateNamesString: states === undefined ? null : states.join(', '),
      metadata
    });
  }

  static getFromSerializedValues(serializedValues: any) {
    return new this({
      bookingTypes: serializedValues.bookingTypes,
      stateNamesString: serializedValues.states.join(', '),
      metadata: serializedValues.metadata
    });
  }

  static getEmptyControlConfig(): { [key: string]: any; } {
    return {
      bookingTypes: [{ value: [], disabled: true }],
      // states: [{ value: [], disabled: true }],
      stateNamesString: [{ value: '', disabled: true }, EditorEligibilityRuleHasBookingType.getStateNamesStringControlOptions()],
      metadata: [{ value: [], disabled: true }]
    };
  }

  static getStateNamesStringControlOptions(): any {
    return {
      validators: [],
      updateOn: 'blur'
    };
  }

  createCopy(): EditorEligibilityRuleHasBookingType {
    return new EditorEligibilityRuleHasBookingType({
      id: this.id,
      bookingTypes: [...this.bookingTypes],
      // states: [...this.states],
      stateNamesString: this.stateNamesString,
      metadata: [...this.metadata]
    });
  }

  getBookingTypesAsString(bookingTypeNames: { id: string, name: string }[]): string {
    if (this.bookingTypes.length === 0) { return ''; }
    return this.bookingTypes
      .map(bookingType =>
        bookingTypeNames.find(bookingTypeName => bookingTypeName.id === bookingType) ?? { id: bookingType, name: $localize `Not valid` }
      )
      .map(bookingTypeName => bookingTypeName.name)
      .join(', ');
  }
/*
  getBookingStatesAsString(bookingStateNames: { id: string, name: string }[]): string {
    if (this.states.length === 0) { return ''; }
    return this.states
      .map(state =>
        bookingStateNames.find(bookingStateName => bookingStateName.id === state) ?? { id: state, name: $localize `Not valid` }
      )
      .map(bookingStateName => bookingStateName.name)
      .join(', ');
  }
*/
  getBookingMetadataAsString(bookingMetadataNames: { id: string, name: string }[]): string {
    if (this.metadata.length === 0) { return ''; }
    return this.metadata
      .map(metadata =>
        bookingMetadataNames.find(bookingMetadataName => bookingMetadataName.id === metadata) ?? { id: metadata, name: $localize `Not valid` }
      )
      .map(bookingMetadataName => bookingMetadataName.name)
      .join(', ');
  }

  getControlsConfig(): { [key: string]: any; } {
    return {
      bookingTypes: [this.bookingTypes],
      // states: [this.states],
      stateNamesString: [this.stateNamesString, EditorEligibilityRuleHasBookingType.getStateNamesStringControlOptions()],
      metadata: [this.metadata],
    };
  }

  getSerializedValues(): any {
    return {
      bookingTypes: this.bookingTypes,
      // states: this.states,
      states: this.stateNamesString === '' ? [] : this.stateNamesString.split(',').map(itm => itm.trim().toUpperCase()),
      metadata: this.metadata
    };
  }
}
